module.exports = __webpack_public_path__ + "static/media/Quais.a07de2ba.webp";